import styled from "styled-components";

export const Container = styled.div`
  z-index: 999;

  .marker-triangle {
    position: absolute;
    top: 0;
    width: 0;
    height: 0;
    border-top: 20px solid rgb(168, 168, 168);
    border-bottom: 0;
    border-left: 0;
    transition: 0.7s cubic-bezier(0.175, 0.885, 0.32, 1.275);
    opacity: 0.4;

    &:hover {
      cursor: col-resize;
      transform: scale(1.25);
      opacity: 1;
    }
  }

  #in-marker {
    border-right: 20px solid transparent;
    transform-origin: top left;
  }

  #out-marker {
    border-left: 20px solid transparent;
    transform-origin: top right;
  }
`;
